<template>
  <div id="menu-admin-component" class="text-white fs-6">
    <div class="row ms-0">
      <div class="col-12">
        <div class="row red-color text-center">
          <div class="col  fs-5">
            {{ title }}
          </div>
        </div>
      </div>
    </div>
    <div class="row ms-0 fs-4">
      <div class="col-11 offset-1 border pt-2" id="categories-container">
        <ul class="ps-0 text-18px">
          <li v-if="userStore.checkFeatureAccess('cart_history')">
            <button
              class="border-0 bg-transparent text-white ps-0 fw-light menu-admin-button fs-5 text-underline"
              type="button"
              data-bs-toggle="collapse"
              :data-bs-target="'#menu-history'"
              :aria-controls="'menu-history'">
              {{ labelMenuHistory }}
            </button>
              <ul
                :id="'menu-history'"
                class="accordion-collapse collapse">
                <li
                  key="carts"
                  class="fs-5 list-style-none text-underline"
                  @click="$router.push('/history/carts')">
                  {{ labelMenuHistoryCarts }}
                </li>
                <li
                  key="ftpReceived"
                  class="fs-5 list-style-none text-underline"
                  @click="$router.push('/history/photos-ftp-received')">
                  {{ labelMenuHistoryFtpReceived }}
                </li>
                <li
                  key="logins"
                  class="fs-5 list-style-none text-underline"
                  @click="$router.push('/history/logins')">
                  {{ labelMenuHistoryLogins }}
                </li>
                <li
                  key="logins"
                  class="fs-5 list-style-none text-underline"
                  @click="$router.push('/history/photo-searchs')">
                  {{ labelMenuHistoryPhotoSearchs }}
                </li>
              </ul>
          </li>
          <li v-if="userStore.checkFeatureAccess('users')">
            <button
              class="border-0 bg-transparent text-white ps-0 fw-light menu-admin-button fs-5 text-underline"
              type="button"
              @click="$router.push('/users')">
              {{ menuUsers }}
            </button>
          </li>
          <li v-if="userStore.checkFeatureAccess('validation')">
            <button
              class="border-0 bg-transparent text-white ps-0 fw-light menu-admin-button fs-5 text-underline"
              type="button"
              @click="$router.push('/photoValidation')">
              {{ menuPhotoValidation }}
            </button>
          </li>
          <!-- <li v-if="userStore.checkFeatureAccess('upload_history')">
            <button
              class="border-0 bg-transparent text-white ps-0 fw-light menu-admin-button fs-5 text-underline"
              type="button"
              @click="$router.push('/uploadHistory')">
              {{ menuUploadHistory }}
            </button>
          </li> -->
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts">

import { Options, Vue } from "vue-class-component";

import { useLanguageStore } from "@/stores/language";
import { useCategoryStore } from "@/stores/category";
import { useUserStore } from "@/stores/user";

import { TEXT_KEYS } from "@/constants";

@Options({
  components: {
  }
})
export default class MenuAdmin extends Vue {
  languageStore = useLanguageStore()
  categoryStore = useCategoryStore()
  userStore = useUserStore()

  get title () {
    return this.languageStore.text(TEXT_KEYS.ADMIN_MENU_TITLE)
  }

  get labelMenuHistory() {
    return this.languageStore.text(TEXT_KEYS.MENU_HISTORY)
  }

  get labelMenuHistoryFtpReceived() {
    return this.languageStore.text(TEXT_KEYS.MENU_HISTORY_FTP_RECEIVED)
  }

  get labelMenuHistoryCarts() {
    return this.languageStore.text(TEXT_KEYS.MENU_HISTORY_CART)
  }

  get labelMenuHistoryLogins() {
    return this.languageStore.text(TEXT_KEYS.MENU_HISTORY_LOGIN)
  }

  get labelMenuHistoryPhotoSearchs() {
    return this.languageStore.text(TEXT_KEYS.MENU_HISTORY_PHOTO_SEARCH)
  }

  get menuCarts () {
    return this.languageStore.text(TEXT_KEYS.ADMIN_MENU_CARTS)
  }

  get menuUsers() {
    return this.languageStore.text(TEXT_KEYS.ADMIN_MENU_USERS)
  }

  get menuPhotoValidation() {
    return this.languageStore.text(TEXT_KEYS.ADMIN_MENU_PHOTO_VALIDATION)
  }

  get menuUploadHistory() {
    return this.languageStore.text(TEXT_KEYS.ADMIN_MENU_UPLOAD_HISTORY)
  }
}
</script>

<style lang="stylus">
.menu-admin-button {
  text-align: start !important
}
</style>